import React, { memo } from 'react';

import { SharedChipProps } from '../../types/SharedChipProps';
import { Chips } from '../Chips/Chips';
import { Layout } from '../Layout/Layout';
import { Section } from '../Section/Section';

interface Group {
  chips: SharedChipProps[];
  title: string;
  limit?: number;
  step?: number;
}

interface Props {
  groups: Group[];
}

export const ChipsGroups = memo(({ groups }: Props) => {
  return (
    <Layout direction="column" spacing={2}>
      {groups.map(({ chips, limit, step, title }) => (
        <Section key={title} heading="h4" title={title}>
          <Chips chips={chips} limit={limit} step={step} />
        </Section>
      ))}
    </Layout>
  );
});
